import { captureException, captureMessage } from '@sentry/react';
import axios from 'axios';
import storeClient from '../../storeClient';
import aplicacionesApi from './aplicaciones';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';

const clientMap = new Map();

const { RAZZLE_API_MARCA_BLANCA } = process.env;

// if (typeof window === "undefined") {
//   store = storeServer
// } else {
//   store = storeClient
// }

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const getDomainToken = async () => {
  if (!isClient) {
    return storeClient.getState().applicationState?.token || '';
  }

  const { hostname } = window.location;
  try {
    const res = await aplicacionesApi.obtenerAplicacion(hostname);
    return res.access_token || '';
  } catch (error) {
    captureException(error);
    return storeClient.getState().applicationState?.token || '';
  }
};

const addRequestInterceptors = (client, token) => {
  client.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
};

const cleanRequestInterceptors = (client) => {
  client.interceptors.request.handlers.forEach((_, index) => {
    client.interceptors.request.eject(index);
  });
};

function applyResponseInterceptors(client) {
  client.interceptors.request.use((config) => {
    config.__startTime = Date.now();
    return config;
  });

  client.interceptors.response.use(
    (response) => {

      if (response && response.data) {
        return response.data.object ? response.data.object : response.data;
      }

      captureMessage('Error con Axios, no hay respuesta o en la respuesta no existe data o status');
      return Promise.reject(response.data);
    },
    (error) => {

      captureException(error);
      return Promise.reject(error);
    }
  );
}

function createMethods(client) {
  return {
    get(path, params = {}) {
      return client.get(path, {
        headers,
        params,
      });
    },
    post(path, data = {}) {
      return client.post(path, data, { headers });
    },
  };
}

const createAxiosInstance = (baseURL, store) => {
  let client;
  let applicationId;
  let token;
  if (!store) {
    const sClient = storeClient;
    applicationId = sClient.getState().applicationState.applicationId;
    token = sClient.getState().applicationState.token;
  } else {
    applicationId = store.applicationState.applicationId;
    token = store.applicationState.token;
  }

  if (clientMap.has(applicationId)) {
    client = clientMap.get(applicationId);
    cleanRequestInterceptors(client);
    addRequestInterceptors(client, token);
  } else {
    // Si no está en el mapa, crear uno nuevo
    client = axios.create({
      baseURL,
      headers,
    });

    applyResponseInterceptors(client);
    addRequestInterceptors(client, token);

    clientMap.set(applicationId, client);
  }

  return createMethods(client);
};

const createAxiosInstanceWithStore = (store) => {
  return createAxiosInstance(RAZZLE_API_MARCA_BLANCA, store);
};

function createBrowserMarcaBlancaClient(baseURL) {
  const client = axios.create({
    baseURL,
    headers,
  });

  applyResponseInterceptors(client);

  client.interceptors.request.use(async (config) => {
    if (!config.headers.Authorization) {
      const token = await getDomainToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
        originalRequest._retry = true;
        const newToken = await getDomainToken();
        if (newToken) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return client(originalRequest);
        }
      }

      return Promise.reject(error);
    }
  );

  return client;
}

const marcaBlancaApiClient = createMethods(createBrowserMarcaBlancaClient(RAZZLE_API_MARCA_BLANCA));

export { marcaBlancaApiClient, createAxiosInstanceWithStore };
